import React, { Component } from 'react';

export class DetailsNav extends Component {
    displayName = DetailsNav.name;

    next = (e) => {
        const { next, validateDetails } = this.props;
        // Terms are accepted when the License Key is obtained, so there is
        // no separate terms acceptance here. canContinue already requires a
        // valid key and a generated Resource Key.
        if (this.props.canContinue) {
            if (validateDetails()) {
                next(e);
            }
        } else {
            // Silence here reads as a broken page, so say what is
            // missing instead.
            e.preventDefault();
            alert('Add a valid License Key above to continue to the ' +
                'Implement step.');
        }
    }

    render() {
        var nextButtonClasses = "b-btn b-btn--large";

        if (!this.props.canContinue)
            nextButtonClasses += " b-btn--disabled";

        return (
            <div className="g-footer__navigation">
                <div className="g-footer__previous">
                    <a href="#" className="b-btn b-btn--large b-btn--secondary" onClick={this.props.previous}><img src="/images/icon-arrow-left-black.svg" className="b-btn__icon" alt="Previous" /><em>Previous step:</em>&nbsp;<strong>Configure Properties</strong></a>
                </div>
                <div className="g-footer__next">
                    <a href="#" className={nextButtonClasses} onClick={this.next}><em>Next step:</em>&nbsp;<strong>Implement</strong><img src="/images/icon-arrow-right-white.svg" className="b-btn__icon b-btn__icon--after" alt="Next" /></a>
                </div>
            </div>
        );
    }
}
